// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__gz_GD","loader-1":"loader_loader-1__9qHfm","loader-2":"loader_loader-2__FFi9w","loader-3":"loader_loader-3__5PDYC","zoomIn":"loader_zoomIn___6WM3"};